import { render, staticRenderFns } from "./Project8.vue?vue&type=template&id=72c31e8d&scoped=true&"
import script from "./Project8.vue?vue&type=script&lang=js&"
export * from "./Project8.vue?vue&type=script&lang=js&"
import style0 from "./Project8.vue?vue&type=style&index=0&id=72c31e8d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c31e8d",
  null
  
)

export default component.exports